<mat-spinner></mat-spinner>
<div class="label">
  {{ text }}
</div>
